// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"19":"1436fc94","625":"eaf6864d","657":"5e6f8b91","844":"b24333bf"}[chunkId] + ".chunk.css";
};